export const maintenanceApiUrls = {
  getSettings: '/v1/maintenance'
};
